module.exports = __webpack_public_path__ + "img/moritz_alexander_jacobs.a85c5166.png";